import { NotificationManager } from 'react-notifications';

import { Events } from '../services/Constants';
import CrmService from '../services/CrmService';
import { withLoading } from './CommonActions';
import { addEvent } from './EventActions';
import { loadPlans } from './PlanActions';
import {
  loadAdminUsers,
  loadPlanRelationshipsResources,
  loadProfileResources,
  loadSkyanAuthorization,
} from './Resources';
import * as types from './Types';

export const loadPlanRelationships = (skipCache = false) =>
  loadPlanRelationshipsResources(skipCache, (o) => {
    if (o !== '') {
      return o;
    }
    return { not_found: true };
  });

export const loadProfile = (skipCache = false) =>
  loadProfileResources(skipCache);

export const saveProfile = withLoading((profile) => {
  return (dispatch, getState) => {
    const {
      okta: {
        accessToken,
        isEmployee,
        user: { email },
      },
    } = getState();
    return CrmService()
      .saveProfile(accessToken, profile)
      .then(() => {
        return dispatch(loadProfile(true)).then(() => {
          dispatch(addEvent(Events.UPDATE_PROFILE));
          dispatch({ type: types.SAVE_PROFILE_SUCCESS });
          return dispatch(loadPlans(email, isEmployee, true)).then(() => {
            NotificationManager.success(
              'Profile saved successfully.',
              'Profile'
            );
          });
        });
      })
      .catch(() => {
        NotificationManager.error('Unable to save profile.', 'Profile');
      });
  };
});

export const saveAdminUsers = withLoading((usrsToSave) => {
  return (dispatch, getState) => {
    const {
      okta: { accessToken },
    } = getState();
    if (usrsToSave.length < 1) {
      return NotificationManager.warning(`No changes to submit`);
    }
    return CrmService()
      .saveAdminUsers(accessToken, usrsToSave)
      .then(() => {
        return dispatch(loadAdminUsers()).then(() =>
          NotificationManager.success(
            'Users access updated successfully.',
            'Admin users'
          )
        );
      })
      .catch(() => {
        NotificationManager.success(
          'Users access updated successfully.',
          'Admin users'
        );
      });
  };
});

export const checkSkyanAuthorization = () => {
  return (dispatch, getState) => {
    const {
      okta: {
        user: { email },
      },
    } = getState();
    return dispatch(loadSkyanAuthorization(email));
  };
};
